module.exports = __webpack_public_path__ + "assets/9e5217fa151b402f58aa25f0f8781404.png";